exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".additinal-wrap .price > div {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.additinal-wrap .price > div .price-original {\n    font-size: 16px;\n}\n", ""]);

// exports
